module.exports = __webpack_public_path__ + "img/cpzs1.6b20d70b.png";